import {
  Divider,
  Stack,
  Text,
  Container,
  Box,
  HStack,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Image,
  Heading,
  SimpleGrid,
  Badge,
  Link,
  Center,
  VStack
} from "@chakra-ui/react";

import { useState } from "react";


import TagsArray from "./TagsArray";

export default function Projects({ color }) {
    
    
    const options = TagsArray("ProjectsTags");
    
    const [selected, setSelected] = useState("All");

    const handleSelected = (value) => {
      setSelected(value);
    };
    
  return (
    <>
      <Container maxW={"3xl"} id="projects">
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          pb={{ base: 20, md: 36 }}
        >
          <Stack align="center" direction="row" p={4}>
            <HStack mx={4}>
              <Text color={`${color}.400`} fontWeight={800}>
                02
              </Text>
              <Text fontWeight={800}>Featured Assets</Text>
            </HStack>
            <Divider orientation="horizontal" />
          </Stack>
          <Stack px={4} spacing={4}>
           
            {/* 1 */}
                <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Index-Image.png" />

                  <Stack>
                    <CardBody align="left">
                      <Heading size="md">2D Card Pack</Heading>

                      <Text py={2}>2D Card Pack containing a total of 127 card templates. 72 cardbacks and   55 cardfronts. It also contains 55 high quality images for the 55 cardfronts.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://youtu.be/lBLxr8fH2GM"}>
                            <Button color={`${color}.400`}>
                              Link
                            </Button>
                          </a>
                       
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                {/* 2 */}
                <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Fire_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Fire Pattern Pack</Heading>

                      <Text py={2}>Seamless fire pattern pack containing 12 variations.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1486878817/seamless-fire-patterns?click_key=ddc7f89481da22051a1b69af01a099de3e02765e%3A1486878817&click_sum=e5624d13&ref=shop_home_active_8"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
             
            {/* 3 */}
            <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Floral_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Floral Pattern Pack</Heading>

                      <Text py={2}>Seamless floral pattern pack containing 20 variations.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1476919114/digital-flower-paper-flower-print?click_key=628fa3f1af3f5233bdea6c19ad9996509cde8594%3A1476919114&click_sum=3b29e57a&ref=shop_home_active_3"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                 {/* 4 */}
            <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/100_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">100 Pieces Pattern Pack</Heading>

                      <Text py={2}>Seamless pattern pack containing 100 variations.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1475106246/100-simple-wallpaper-patterns?click_key=8a8a2986d7d734947320de2486a382383fb37683%3A1475106246&click_sum=48ae98f1&ref=shop_home_active_5"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                   {/* 5 */}
            <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Camo_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Camo Pattern Pack</Heading>

                      <Text py={2}>Seamless Camo pattern pack containing 28 variations.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1476435782/camo-pattern-pack?click_key=deb38cd037131b4bda15ffb72612730be0d477ee%3A1476435782&click_sum=599fe8a9&ref=shop_home_active_4"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                 {/* 6 */}
            <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Chinese_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Chinese Pattern Pack</Heading>

                      <Text py={2}>Seamless Chinese pattern pack containing 32 variations.</Text>

                       <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1486922057/seamless-chinese-plate-patterns?click_key=5ce00e7591fb57e1e3067885dd587c9a8fe6d599%3A1486922057&click_sum=26614375&ref=shop_home_active_7"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                {/* 7 */}
            <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Magenta_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Magenta Pattern Pack</Heading>

                      <Text py={2}>Seamless Magenta Flower pattern pack containing 12 variations.</Text>
                      
                      <Stack direction={{ base: "column", sm: "row" }} py={2}>
                     
                          <a  target="_blank" href={"https://www.etsy.com/listing/1473590276/seamless-purple-flower-pattern-pack?click_key=1e416a166fef838296ddbf183d91b8cdffcf6f22%3A1473590276&click_sum=340084b6&ref=shop_home_active_6"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                          
                      </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
                <Card
                  
                  direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                >
                  <Image objectFit="cover" src="../../assets/Tropical_Main.png" />

                  <Stack>
                  <CardBody align="left">
                      <Heading size="md">Tropical Pattern Pack</Heading>

                      <Text py={2}>Seamless Tropical pattern pack containing 20 variations.</Text>

                      <Stack direction={{ base: "column", sm: "row" }} py={2}>
                       
                          <a  target="_blank" href={"https://www.etsy.com/listing/1491562821/seamless-tropical-patterns-digital?click_key=99f7165f247042daec6972f87e2a78b0a437a5d4%3A1491562821&click_sum=7b86af0d&ref=shop_home_active_2"}>
                            <Button color={`${color}.400`}>
                              Etsy Link
                            </Button>
                          </a>
                          <a   target="_blank" href={""}>
                            <Button  color={`${color}.400`}>
                              Creative Market Link
                            </Button>
                          </a>   
                          </Stack>
                     
                    </CardBody>
                     
                  </Stack>
                </Card>
          </Stack>
         
        </Stack>
      </Container>
    </>
  );
}
